import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navigation: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className="nav">
      <div className="nav-content">
        <Link to="/" className="nav-logo">
          SELENAY OĞUZ
        </Link>

        <button 
          className="mobile-menu-btn"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle menu"
        >
          {isOpen ? '✕' : '☰'}
        </button>

        <ul className={`nav-links ${isOpen ? 'active' : ''}`}>
          <li>
            <Link 
              to="/" 
              className={`nav-link ${isActive('/') ? 'active' : ''}`}
              onClick={() => setIsOpen(false)}
            >
              Ana Sayfa
            </Link>
          </li>
          <li>
            <Link 
              to="/hizmetler" 
              className={`nav-link ${isActive('/hizmetler') ? 'active' : ''}`}
              onClick={() => setIsOpen(false)}
            >
              Hizmetler
            </Link>
          </li>
          <li>
            <Link 
              to="/projeler" 
              className={`nav-link ${isActive('/projeler') ? 'active' : ''}`}
              onClick={() => setIsOpen(false)}
            >
              Projeler
            </Link>
          </li>
          <li>
            <a 
              href="/#iletisim" 
              className="nav-link"
              onClick={() => setIsOpen(false)}
            >
              İletişim
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navigation;
